<style lang="less" scoped>
  .header-area {
    padding-bottom: 16px;
  }
  .content {
    width: 100%;
    overflow-y: auto;
    align-items: flex-start;
    padding: 16px 0;
  }
  .result-container {
    width: 100%;
  }
  .row {
    width: 100%;
  }
  .numbering {
    color: white;
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
    margin-bottom: 16px;
    padding: 0 5px;
  }
  .col {
    width: 20%;
  }
  .image-row {
    display: flex;
    margin-bottom: 8px;
  }
  .image-frame {
    width: 64px;
    height: 64px;
    overflow: hidden;
    border-radius: 12px;
    margin: auto;
    position: relative;
    .filter {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      &.correct {
        background-color: rgba(0, 255, 0, .4);
      }
      &.wrong {
        background-color: rgba(255, 0, 0, .4);
      }
    }
    .image-panel-component {
      width: 100%;
      height: 100%;
    }
  }
  .footer {
    padding-top: 16px;
  }
</style>

<template lang="pug">
  .std-layout
    .header-area
      header-component(
        @click-stop='redirectBack'
        @click-complete='done')
    .content
      .result-container
        .row(v-for='(row, key) in group')
          .numbering {{key + 1}}행
          .image-area
            .answer.image-row
              .col(v-for='answer in row.answer')
                .image-frame
                  image-panel-component.image-panel-component(:image='answer')
            .input.image-row
              .col(v-for='(input, key) in row.input')
                .image-frame
                  .filter(
                    :class='{ correct: input === row.answer[key], wrong: input !== row.answer[key] }')
                  image-panel-component.image-panel-component(:image='input')
    .footer
      button-component.btn(
        @click='done'
        :text='"결과보기"')
</template>

<script>
import HeaderComponent from '@/components/header/stop';
import ImagePanelComponent from '@/components/image_panel';
import ButtonComponent from '@/components/button';
import FooterComponent from '@/components/footer/timer_arrow';

import GameType from '@/game';

export default {
  data() {
    return {
      group: [], // [[ {answer: xxx, input: xxx} ... ], [...]]
      score: 0,
    };
  },
  methods: {
    addBestRecord(time, score) {
      const data = JSON.stringify({ time, score });
      this.$localStorage.set(this.localStorageKey, data);
    },
    loadBestRecord() {
      const data = JSON.parse(this.$localStorage.get(this.localStorageKey));
      return this.$localStorage.get(this.localStorageKey) ? data : { score: 0, time: 0 };
    },
    redirectBack() {
      this.$router.go(-1);
    },
    done() {
      this.$store.commit('setScore', this.score);
      this.$store.commit('setUsedTime', this.time * 60);
      this.$router.replace({ name: 'Result' });
    },
    grouping(answer, units) {
      const group = [];
      const groupCount = Math.ceil(answer.length / units);
      for (let i = 0; i < groupCount; i += 1) {
        const start = i * this.units;
        const end = start + this.units;
        const answerArr = [];
        const inputArr = [];
        for (let j = start; j < end; j += 1) {
          if (!(j in this.answer)) {
            break;
          }
          const answerData = this.answer[j];
          const inputData = j in this.input ? this.input[j] : false;
          if (!answerData) {
            return false;
          }
          answerArr.push(answerData);
          inputArr.push(inputData);
        }
        group.push({ answer: answerArr, input: inputArr });
      }
      return group;
    },
    getScore() {
      let score = 0;
      const group = this.group;
      const row = group.length;
      for (let i = 0; i < row; i += 1) {
        const answerRow = this.group[i].answer;
        const inputRow = this.group[i].input;
        for (let j = 0; j < answerRow.length; j += 1) {
          const answer = answerRow[j];
          const input = j in inputRow ? inputRow[j] : false;
          if (answer === input) {
            score += 1;
          }
        }
      }
      return score;
    },
    setBestRecord() {
      const record = this.loadBestRecord();
      const score = record.score || 0;
      if (score < this.score) {
        this.addBestRecord(this.time * 60, this.score);
      }
    },
    addStoreBestScore() {
      const data = this.loadBestRecord();
      this.$store.commit('setBestScore', data.score);
    },
    addStoreBestTime() {
      const data = this.loadBestRecord();
      this.$store.commit('setBestTime', data.time);
    },
    // test() {
    //   this.group[0].input.splice(1, 1);
    // },
  },
  computed: {
    bestScore() {
      return this.$store.state.app.bestScore;
    },
    bestTime() {
      return this.$store.state.app.bestTime;
    },
    localStorageKey() {
      const arr = [GameType.mode.training, GameType.game.image, this.time];
      return arr.join('.');
    },
    answer() {
      return this.$store.state.app.answer;
    },
    units() {
      return this.$store.state.app.units;
    },
    input() {
      return this.$store.state.app.input;
    },
    time() {
      return this.$store.state.app.time;
    },
  },
  mounted() {
    this.group = this.grouping(this.answer, this.units);
    this.score = this.getScore();
    this.setBestRecord();
    this.addStoreBestScore();
    this.addStoreBestTime();
  },
  components: {
    HeaderComponent,
    ImagePanelComponent,
    ButtonComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/image/result.vue